import Vue from 'vue';
import Vuex from 'vuex';
import menu from './modules/menu';
import window from './modules/window';
import modal from './modules/modal';
import data from './modules/data';
import app from './modules/app';
import user from './modules/user';
import auth from './modules/auth';
import receipts from './modules/receipts';
import tickets from './modules/tickets';
import ticketsV2 from './modules/tickets_v2';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    user,
    auth,
    menu,
    window,
    modal,
    data,
    receipts,
    tickets,
    ticketsV2
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js